


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { snackModule } from '@/store';
import { EmailConfirmation } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  loading: boolean = false;

  emailConfirmation: EmailConfirmation | null = null;

  success: boolean = false;
  error: string = '';

  async mounted() {
    try {
      this.loading = true;
      const queryUid = this.$route.query.uid;
      const queryToken = this.$route.query.token;

      if (!queryUid || !queryToken) {
        this.$router.push({ name: 'not-found' });
      } else {
        const emailObj = {
          uid: queryUid,
          token: queryToken,
        };
        this.emailConfirmation = new EmailConfirmation(emailObj);
        await this.emailConfirmation.save();
        this.success = true;
      }
    } catch (err) {
      // Not found
      this.error = err.response.errors[0].detail;
    } finally {
      this.loading = false;
    }
  }
}
